const ku = {
  app_name: 'Dr Bardawam',
  home: 'سەرەکی',
  categories: 'پۆلەکان',
  categories_layout_6: 'پیشاندانی ٦ پۆل',
  categories_layout_9: 'پیشاندانی ٩ پۆل',
  medical_consultation: 'ڕاوێژی پزیشکی',
  no_image: 'وێنە نییە',
  products: 'بەرهەمەکان',
  vip_products: 'بەرهەمی VIP',
  vip_badge: 'VIP',
  products_empty: 'هیچ بەرهەمێک نییە لەم پۆلەدا',
  add_to_cart: 'زیادکردن بۆ سەبەتە',
  added_to_cart: 'زیادکرا بۆ سەبەتە',
  product_unavailable: 'بەردەست نییە',
  discount_off: 'داشکاندن',
  price_ask_message: 'بۆ زانستی نرخ نامە بنێرە',
  view_cart: 'بینینی سەبەتە',
  cart_title: 'سەبەتە',
  cart_empty: 'سەبەتەکەت بەتاڵە',
  cart_empty_message: 'هیچ بەرهەمێکت لە سەبەتەدا نییە. تکایە بەرهەمێک هەڵبژێرە و زیادی بکە بۆ سەبەتە.',
  cart_added_message: 'بەرهەمەکە بە سەرکەوتوویی زیادکرا بۆ سەبەتەکەت.',
  cart_a11y: 'سەبەتە',
  cart_service_title: 'جۆری داواکاری',
  cart_delivery_only: 'تەنها پێویستم بە گەیاندن هەیە',
  cart_delivery_install: 'پێویستم بە گەیاندن و چاککردن هەیە',
  cart_subtotal: 'کۆی لاوەکی',
  cart_discount: 'داشکاندن',
  cart_line_total: 'کۆ',
  cart_delivery_fee: 'کرێی گەیاندن',
  cart_delivery_free: 'گەیاندنی خۆڕایی',
  cart_delivery_city: 'شار',
  cart_offer_discount: 'داشکاندنی ئۆفەر',
  cart_grand_total: 'کۆی گشتی',
  cart_city_unknown: 'نەتوانرا شار دیاری بکرێت',
  cart_city_outside: 'شوێنەکەت دەرەوەی ناوچەی گەیاندنە',
  cart_zone_loading_title: 'تکایە چاوەڕێ بکە',
  cart_zone_loading_message: 'تا زۆنەکەت دیار دەکەین...',
  cart_out_of_zone_title: 'ببورە',
  cart_out_of_zone_message: 'گەیاندنمان نییە بۆ ئەم شارە. تکایە لە ناوچەی گەیاندن بیت بۆ ناردنی داواکاری.',
  cart_place_order: 'ناردنی داواکاری',
  cart_consult_whatsapp: 'ڕاوێژ لە ڕێگەی واتساپ',
  cart_order_success: 'داواکاری نێردرا',
  cart_order_success_message: 'بەم زووانە پەیوەندیت پێوە دەکرێت',
  cart_order_failed: 'ناردنی داواکاری سەرکەوتوو نەبوو',
  cart_consult_opened: 'واتساپ کرایەوە',
  cart_consult_opened_message: 'داواکاری ڕاوێژەکەت لە واتساپ ئامادەیە بۆ ناردن',
  cart_login_required: 'تکایە سەرەتا تۆمار ببە بۆ ناردنی داواکاری',
  cart_city_required: 'تکایە لە ناوچەی گەیاندن بیت بۆ ناردنی داواکاری',
  cart_refresh_location: 'نوێکردنەوەی شوێن',
  cart_view_delivery_offers: 'زانیاری گەیاندن و ئۆفەر',
  cart_wa_order_title: 'داواکاری نوێ — Dr Bardawam',
  cart_wa_consult_title: 'ڕاوێژی پزیشکی — Dr Bardawam',
  cart_wa_name: 'ناو',
  cart_wa_phone: 'ژمارە',
  cart_wa_city: 'شار',
  cart_wa_location: 'شوێن',
  cart_wa_map: 'نەخشە',
  cart_wa_items: 'بەرهەمەکان',
  cart_wa_note: 'تێبینی',
  cart_wa_subtotal: 'کۆ',
  cart_wa_delivery: 'گەیاندن',
  cart_wa_free_delivery: 'خۆڕایی',
  cart_wa_grand_total: 'کۆی گشتی',
  product_consult_whatsapp: 'ڕاوێژ لە واتساپ',
  product_wa_consult_title: '💬 داواکاری ڕاوێژ — Dr Bardawam',
  product_wa_product: 'بەرهەم',
  product_wa_price: 'نرخ',
  product_wa_original_price: 'نرخی پێشوو',
  product_wa_discount: 'داشکاندن',
  product_description: 'وەسف',
  product_price: 'نرخ',
  product_note: 'تێبینی',
  order_note: 'تێبینی داواکاری',
  order_note_placeholder: 'تێبینیەکەت بنووسە',
  special_instructions: 'ڕێنمایی تایبەت',
  special_instructions_placeholder: 'ڕێنمایی تایبەتەکەت بنووسە ',
  quantity: 'ژمارە',
  increase_quantity: 'زیادکردنی ژمارە',
  decrease_quantity: 'کەمکردنی ژمارە',
  remove_from_cart: 'لابردن لە سەبەتە',
  favourite_a11y: 'دڵخواز',
  search: 'گەڕان',
  search_placeholder: 'گەڕان بۆ بەرهەم...',
  search_hint: 'بنوسە بۆ گەڕانی بەرهەمەکان',
  search_no_results: 'هیچ ئەنجامێک نیە بۆ «{{query}}»',
  Settings: 'ڕێکخستنەکان',
  Account: 'هەژمار',
  footer_tagline: 'دەرمان و بەرهەمی تەندروستی بە گەیاندنی خێرا بۆ ماڵەکەت.',
  footer_quick_links: 'لینکە خێراکان',
  social_media: 'تۆڕە کۆمەڵایەتییەکان',
  follow_us: 'شوێنمان بکەون لە تۆڕە کۆمەڵایەتییەکان',
  all_rights_reserved: 'هەموو مافەکان پارێزراون.',
  created_by: 'دروستکراوە لەلایەن',
  Welcome: 'بەخێربێیت',
  Profile: 'پرۆفایل',
  'orders.header': 'داواکارییەکانم',
  orders_empty: 'هیچ داواکارییەک نییە',
  orders_load_failed: 'نەتوانرا داواکارییەکان بار بکرێن',
  orders_total: 'کۆی گشتی',
  orders_currency: 'د.ع',
  orders_items_count: '{{count}} بەرهەم',
  orders_status_unknown: 'نەناسراو',
  orders_status_pending: 'چاوەڕوان',
  orders_status_processing: 'لە جێبەجێکردندا',
  orders_status_completed: 'تەواو',
  orders_status_delivered: 'گەیاندرا',
  orders_status_cancelled: 'هەڵوەشاوە',
  orders_number: 'ژمارەی داواکاری',
  orders_date: 'بەروار',
  orders_delivery: 'جۆری گەیاندن',
  orders_delivery_fee: 'کرێی گەیاندن',
  orders_delivery_free: 'گەیاندنی خۆڕایی',
  orders_city: 'شار',
  orders_location: 'شوێن',
  orders_discount: 'داشکاندن',
  orders_delivery_delivery: 'تەنها گەیاندن',
  orders_delivery_delivery_setup: 'گەیاندن و چاککردنەوە',
  orders_delivery_delivery_only: 'تەنها گەیاندن',
  orders_retry: 'دووبارە هەوڵبدەرەوە',
  orders_status_confirmed: 'پشتڕاستکراو',
  orders_status_approved: 'پەسندکراو',
  orders_status_rejected: 'ڕەتکراوە',
  orders_status_shipped: 'نێردرا',
  orders_status_new: 'نوێ',
  Favourites: 'دڵخوازەکان',
  favourites_empty: 'هیچ دڵخوازێکت نییە',
  favourites_load_failed: 'نەتوانرا دڵخوازەکان بار بکرێن',
  favourites_remove_failed: 'لابردن لە دڵخواز سەرکەوتوو نەبوو',
  favourites_save_failed: 'پاشەکەوتکردنی دڵخواز سەرکەوتوو نەبوو',
  favourites_login_required: 'تکایە سەرەتا بچۆرە ژوورەوە بۆ پاشەکەوتکردنی دڵخواز',
  remove_favourite: 'لابردن لە دڵخواز',
  Logout: 'چوونەدەرەوە',
  'Delete Account': 'سڕینەوەی هەژمار',
  Register: 'تۆمارکردن',
  Login: 'چوونەژوورەوە',
  login_create_account: 'چوونەژوورەوە یان دروستکردنی هەژمار',
  login_subtitle: 'بۆ ناردنی داواکاری و هەژمار دروست بکە',
  login_step_phone: 'مۆبایل',
  login_step_otp: 'کۆد',
  login_step_signup: 'تۆمار',
  login_phone: 'ژمارەی مۆبایل',
  login_phone_placeholder: '07XX XXX XXXX',
  login_otp: 'کۆدی پشتڕاستکردنەوە',
  login_otp_placeholder: '000000',
  login_send_otp: 'ناردنی کۆد',
  login_verify_otp: 'پشتڕاستکردنەوەی کۆد',
  login_signup_submit: 'تۆمارکردن',
  login_full_name: 'ناوی تەواو',
  login_full_name_placeholder: 'ناوی تەواوت بنووسە',
  login_location: 'شوێن',
  login_location_button: 'دیاریکردنی شوێنەکەم',
  login_continue: 'بەردەوامبوون',
  login_error: 'هەڵە',
  login_phone_invalid: 'ژمارەی مۆبایل دروست بنووسە',
  login_send_otp_first: 'سەرەتا کۆد بنێرە',
  login_otp_invalid: 'کۆدی پشتڕاستکردنەوە بنووسە',
  login_otp_wrong: 'کۆدەکە هەڵەیە',
  login_name_required: 'ناوی تەواو پێویستە',
  login_location_required: 'تکایە شوێنەکەت دیاری بکە',
  login_location_denied: 'ڕێگەی شوێن نەدراوە',
  login_location_failed: 'نەتوانرا شوێن وەربگیرێت',
  login_otp_sent: 'کۆد نێردرا',
  login_otp_sent_message: 'کۆدەکە پشکنین بکە لە پەیامەکاندا',
  login_otp_demo: 'کۆدی تاقیکردنەوە:',
  login_save_failed: 'پاشەکەوتکردن سەرکەوتوو نەبوو',
  login_request_failed: 'داواکاری سەرکەوتوو نەبوو. دووبارە هەوڵ بدەرەوە',
  login_token_missing: 'token وەرنەگیرا. دووبارە هەوڵ بدەرەوە',
  signin_subtitle: 'ژمارەی مۆبایل و کۆد بنووسە بۆ چوونەژوورەوە',
  signin_no_account: 'هەژمار نییە. تکایە سەرەتا تۆمار بکە',
  signin_go_register: 'هەژمار نییە؟ تۆمار بکە',
  register_subtitle: 'هەژمارێکی نوێ دروست بکە بۆ ناردنی داواکاری',
  register_go_signin: 'هەژمارت هەیە؟ چوونەژوورەوە',
  register_already_has_account: 'ئەم ژمارەیە پێشتر تۆمار کراوە. تکایە بچۆرە ژوورەوە',
  profile_save: 'پاشەکەوتکردن',
  profile_load_failed: 'نەتوانرا پرۆفایل بار بکرێت',
  profile_update_failed: 'نوێکردنەوەی ناو سەرکەوتوو نەبوو',
  profile_update_success: 'سەرکەوتوو',
  profile_update_success_message: 'ناوەکەت نوێکرایەوە',
  Setting: 'ڕێکخستنەکان',
  Theme: 'ڕووکار',
  Language: 'زمان',
  Fonts: 'فۆنت',
  'Help & Information': 'یارمەتی و زانیاری',
  delivery_info_title: 'زانیاری گەیاندن و ئۆفەر',
  delivery_info_intro: 'بەکارھێنانی ئازیزی زانیاریی دەربارەی گەیاندن و ئۆفەرەکان',
  delivery_info_cities_section: 'جۆری گەیاندن بەپێی شار',
  delivery_info_offers_section: 'جۆری ئۆفەرەکان',
  delivery_info_farewell: 'هەمیشە تەندروست باش بن',
  delivery_info_empty: 'هیچ زانیارییەک بەردەست نییە',
  delivery_info_load_failed: 'نەتوانرا زانیاری بار بکرێت',
  delivery_offer_type_free: 'گەیاندنی خۆڕایی',
  delivery_offer_type_discount: 'داشکاندن',
  delivery_page: 'گەیاندن',
  offers_page: 'ئۆفەرەکان',
  'share App': 'هاوبەشکردنی ئەپ',
  'Rate Us': 'هەڵسەنگاندن',
  select_language: 'زمان هەڵبژێرە',
  close: 'داخستن',
  'Select Font': 'فۆنت هەڵبژێرە',
  'Select Theme': 'ڕووکار هەڵبژێرە',
  'Light Mode': 'ڕووناک',
  'Dark Mode': 'تاریک',
  'Black Mode': 'ڕەش',
  'font one': 'فۆنتی یەکەم',
  'font two': 'فۆنتی دووەم',
  'font three': 'فۆنتی سێیەم',
  'System default': 'فۆنتی سیستەم',
  confirm_logout_message: 'دڵنیایت لە چوونەدەرەوە؟',
  confirm_delete_message: 'دڵنیایت لە سڕینەوەی هەژمار؟',
  logout: 'چوونەدەرەوە',
  already_logged_in: 'تۆ پێشتر چوویتە ژوورەوە وەک {{name}}',
  go_to_profile: 'چوون بۆ پرۆفایل',
  delete: 'سڕینەوە',
  cancel: 'پاشگەزبوونەوە',
  logout_failed: 'چوونەدەرەوە سەرکەوتوو نەبوو',
  version_label: 'وەشان {{version}}',
  go_back: 'گەڕانەوە',
  account_a11y: 'هەژمار',
  search_a11y: 'گەڕان',
  onboarding_skip: 'تێپەڕاندن',
  onboarding_next: 'دواتر',
  onboarding_back: 'گەڕانەوە',
  onboarding_tap_to_continue: 'بۆ بەردەوامبوون پەپکە بکە',
  onboarding_get_started: 'دەستپێکردن',
  onboarding_step_lang: 'زمان',
  onboarding_step_theme: 'ڕووکار',
  onboarding_step_font: 'فۆنت',
  onboarding_splash_tagline: 'ئەلیکترۆنیات لە فرۆشگای فۆمسی',
  onboarding_lang_title: 'زمان هەڵبژێرە',
  onboarding_lang_subtitle: 'زمانی دڵخوازت بۆ ئەپەکە دیاری بکە',
  onboarding_theme_title: 'ڕووکار هەڵبژێرە',
  onboarding_theme_subtitle: 'ڕووناک، تاریک یان ڕەش — هەر کات دەتوانیت بیگۆڕیت',
  onboarding_font_title: 'فۆنت هەڵبژێرە',
  onboarding_font_subtitle: 'فۆنتێک هەڵبژێرە کە بۆ خوێندنەوە ئاسان بێت',
  onboarding_font_sample: 'نموونەی دەق',
  network_offline_title: 'هیچ پەیوەندییەکی ئینتەرنێت نییە',
  network_offline_message: 'تکایە Wi-Fi یان داتای مۆبایل بپشکنە و دووبارە هەوڵ بدەرەوە',
  network_retry: 'دووبارە هەوڵبدەرەوە',
  notifications_title: 'ئاگادارکردنەوەکان',
  notifications_subtitle: 'ئاگادارکردنەوە و دەنگی ئۆتۆماتیک ڕێکبخە',
  notifications_enable: 'چالاککردنی ئاگادارکردنەوە',
  notifications_enable_desc: 'ئاگادارکردنەوە وەربگرە کاتێک داواکاری یان پەیام هەیە',
  notifications_sound: 'دەنگی ئاگادارکردنەوە',
  notifications_sound_desc: 'دەنگ بە شێوەیەکی خۆکار لێبدە کاتێک ئاگادارکردنەوە دێت',
  notifications_permission_status: 'دۆخی مۆڵەت',
  notifications_status_granted: 'چالاکە',
  notifications_status_denied: 'ڕەتکراوە',
  notifications_status_undetermined: 'دیاری نەکراوە',
  notifications_success: 'سەرکەوتوو',
  notifications_enabled_message: 'ئاگادارکردنەوەکان چالاک کران',
  notifications_error: 'هەڵە',
  notifications_permission_denied: 'مۆڵەتی ئاگادارکردنەوە نەدرا',
  notifications_enable_failed: 'چالاککردنی ئاگادارکردنەوە سەرکەوتوو نەبوو',
  notifications_sound_failed: 'گۆڕینی دەنگ سەرکەوتوو نەبوو',
  notifications_android_settings_hint: 'لە ڕێکخستنەکانی ئامێرەکەت مۆڵەت بدە',
  'version.updateAvailableTitle': 'نوێکردنەوە پێویستە',
  'version.updateAvailableMessage':
    'وەشانی نوێی ئەپەکە بەردەستە. تکایە نوێی بکەرەوە بۆ بەردەوامبوون.',
  'version.update': 'نوێکردنەوە',
  download_app_title: 'ئەپەکە دابەزێنە',
  download_app_subtitle: 'ئەپی Dr Bardawam دابەزێنە بۆ مۆبایلەکەت و بە ئاسانی داواکاری بکە.',
  download_ios: 'دابەزاندن بۆ iOS',
  download_android: 'دابەزاندن بۆ ئەندرۆید',
  download_app_hint: 'ئەپەکە بۆ هەر دوو سیستەمی ئەندرۆید و ئای ئۆ ئێس بەردەستە.',
  download_app_page: 'دابەزاندنی ئەپ',
  download_app_badge: 'بەردەستە بۆ مۆبایل',
  download_get_it_on: 'دابەزاندن لە',
  download_why_title: 'بۆچی ئەپەکەمان؟',
  download_why_subtitle: 'تایبەتمەندییەکانی ئەپی Dr Bardawam',
  download_feat_fast_title: 'خێرایی بەرز',
  download_feat_fast_desc: 'ئەپەکە بە خێرایی کار دەکات و وەڵام دەداتەوە',
  download_feat_delivery_title: 'گەیاندنی خێرا',
  download_feat_delivery_desc: 'بەرهەمەکان بە خێرایی دەگەیەنین بۆ ماڵەکەت',
  download_feat_secure_title: 'پاراستنی زانیاری',
  download_feat_secure_desc: 'زانیارییەکانت بە تەواوی پاراستراون',
  download_feat_easy_title: 'بەکارهێنانی ئاسان',
  download_feat_easy_desc: 'دیزاینی ئاسان و ڕەوان بۆ هەمووان',
  download_cta_title: 'ئێستا دابەزێنە!',
  download_banner_desc: 'بەردەستە بۆ ئەندرۆید و iOS',
  home_download_title: 'ئەپلیکەیشنی بەردەوام دابەزێنە',
  home_download_subtitle:
    'بۆ دیار و خەڵات و داشکان و گەیاندنی خۆڕایی، ئەپلیکەیشنی بەردەوام دابەزێنە و سوودمەند بە.',
  home_download_cta: 'دابەزاندنی ئەپ',
  home_download_gift: 'دیار',
  home_download_reward: 'خەڵات',
  home_download_discount: 'داشکان',
  home_download_free_delivery: 'گەیاندنی خۆڕایی',
};

export default ku;
